// src/components/Papers/SearchBar.jsx
import React from 'react';
import { Search } from 'lucide-react';

export const SearchBar = ({ value, onChange, onSearch }) => {
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    return (
        <div className="relative flex w-full gap-2">
            <input
                type="text"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
                placeholder="Search papers..."
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            <button
                onClick={onSearch}
                className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
            >
                <Search className="w-5 h-5" />
            </button>
        </div>
    );
};


